<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12" sm="3">
        <v-card class="text-center ma-2">
          <h3 class="pb-3 pt-3"> {{ payinsurancesessions }}</h3>
          <p class="pa-3 primary--text"> Payment Transactions </p>
          <v-btn text class="pb-4" to="/payforinsurance"> View More </v-btn>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3">
        <v-card class="text-center ma-2">
          <h3 class="pb-3 pt-3"> {{ referencesessions }} </h3>
          <p class="pa-3 primary--text">Reference Transactions</p>
          <v-btn text class="pb-4" to="/reference"> View More </v-btn>
        </v-card>
      </v-col>
       <v-col cols="12" sm="3">
        <v-card class="text-center ma-2">
          <h3 class="pb-3 pt-3"> {{ contactcentersessions }} </h3>
          <p class="pa-3 primary--text">Open Contact Customer Care queries</p>
          <v-btn text class="pb-4" to="/contactcenter"> View More </v-btn>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3">
        <v-card class="text-center ma-2">
          <h3 class="pb-3 pt-3"> {{ contactcentersessions + payinsurancesessions + referencesessions }}  </h3>
          <p class="pa-3 primary--text"> Total Sessions </p>
          <v-btn text class="pb-4" to="/session"> View More </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Home',
  data: () => ({
  }),
  computed: mapState({
    contactcentersessions: state => state.botsession.contactcentersessions,
    payinsurancesessions: state => state.botsession.payinsurancesessions,
    referencesessions: state => state.botsession.referencesessions
  }),
  created () {
    this.$store.dispatch('botsession/getContactCustomerCare')
    this.$store.dispatch('botsession/getPayForInsurance')
    this.$store.dispatch('botsession/getReferenceTransactions')
  }
}
</script>
